import store from "redux/store";

const trackError = async (error, extraAttributes) => {
  if (process.env.REACT_APP_ENABLE_NEWRELIC === "false") return;

  const customAttributes = {
    ...extraAttributes,
  };

  try {
    const { auth } = store.getState();

    customAttributes.authUserId = auth.user?.id;
    customAttributes.authUsername = auth.user?.username;
    customAttributes.publicIp = auth.publicIp;
  } catch (trackerError) {
    window.newrelic.noticeError(trackerError, {
      trackerError: "true", // New Relic ignores boolean values in some views
    });
  }

  await window.newrelic.noticeError(error, customAttributes);
};

export { trackError };
